import './index.scss'
import useSalesforceLead from 'hooks/salesforce/useSalesforceLead'
import useSalesforceCase from 'hooks/salesforce/useSalesforceCase'

const SalesforceSync: React.FC = () => {
  const {
    isSuccess: leadIsSuccess,
    isFetching: leadIsFetching,
    refetch: refetchLead,
    hasLeadId,
    lead,
  } = useSalesforceLead()

  const {
    isSuccess: caseIsSuccess,
    isFetching: caseIsFetching,
    refetch: refetchCase,
    hasCaseId,
    sfAccount,
  } = useSalesforceCase()

  if (!hasLeadId && !hasCaseId) {
    return null
  }

  const isFetching = hasLeadId ? leadIsFetching : caseIsFetching
  const isSuccess = hasLeadId ? leadIsSuccess : caseIsSuccess
  const refetch = hasLeadId ? refetchLead : refetchCase

  const accountFirstLast = `${sfAccount?.FirstName ?? ''} ${
    sfAccount?.LastName ?? ''
  }`.trim()
  const label = hasLeadId
    ? `${lead?.FirstName ?? ''} ${lead?.LastName ?? ''}`.trim()
    : accountFirstLast || sfAccount?.Name || ''

  return (
    <div
      className={`loadingBox ${isSuccess && !isFetching ? 'success' : ''}`}
      style={{ flexGrow: 1, textAlign: 'center' }}
      onClick={() => refetch?.()}
    >
      {isFetching ? 'Syncing With Salesforce' : label}
    </div>
  )
}

export default SalesforceSync
